import "./AddComponentDialog.scss";
import Dialog from "../../../dialogs/Dialog";
import { useState, useRef } from "react";
import Input from "../../../forms/Input";
import DropDownList from "../../../forms/DropDownList";


export default function SectionDialog({ setOpen, isOpen, setBuildArea, editSectionData, parentSetOpen, count }) {
    const formRef = useRef(null);

    const lineTypes = [
        { value: "none", label: "Žiadna" },
        { value: "solid", label: "Plná" },
        { value: "dotted", label: "Bodkovaná" },
        { value: "dashed", label: "Čiarkovaná" },
        { value: "double", label: "Dvojitá" },
    ];

    const [sectionTitle, setSectionTitle] = useState(editSectionData ? editSectionData.title : '');
    const [lineUpType, setLineUpType] = useState("none");
    const [lineDownType, setLineDownType] = useState("none");

    const handleConfirm = () => formRef.current?.requestSubmit();

    const handleClose = () => {
        setSectionTitle("");

        setLineUpType(null);
        setLineDownType(null);

        setOpen(false);
        if (parentSetOpen)
            parentSetOpen(false)
    }

    const titleFactory = (title) => ({ type: "row", data: [{ type: "column", data: [{ type: "title", title: title, field: Date.now().toString() }] }] });

    const lineFactory = (type) => ({ type: "line", line: type });

    const addSection = () => {
        setBuildArea(prev => {
            const newBuildArea = [...prev];

            const sectionElements = [
                titleFactory(sectionTitle),
                ...(lineUpType !== "none" ? [lineFactory(lineUpType)] : []),
                ...(lineDownType !== "none" ? [lineFactory(lineDownType)] : [])
            ];

            newBuildArea.splice(count, 0, ...sectionElements);
            return newBuildArea;
        });
    };

    const handleSave = (e) => {
        e.preventDefault()
        if (sectionTitle.trim() === '')
            return;
        addSection();
        handleClose();
    };

    return (
        <Dialog
            title={editSectionData ? "Nastavenia sekcie" : "Nová sekcia"}
            isOpen={isOpen}
            onClose={handleClose}
            onConfirm={handleConfirm}
            className={"AkcUiDesigner"}
            level={1}
            width={window.innerWidth / 3}
        >
            <form ref={formRef} onSubmit={handleSave}>
                <div className="add-dialog-body">
                    <div className="form-group">
                        <label htmlFor="sectionTitle">Názov sekcie</label>
                        <Input
                            name="sectionTitle"
                            type="text"
                            className={"add-dialog-form-control"}
                            id="sectionTitle"
                            placeholder="Zadajte názov sekcie"
                            value={sectionTitle}
                            onChange={(_, v) => setSectionTitle(v)}
                            required
                            minLength={3}
                        />
                    </div>
                    <label style={{ marginBottom: "5px" }} htmlFor="">Oddelovacie čiary</label>
                    <div className="form-group">
                        <div className="line-settings-row">
                            <div className="line-settings-select">
                                <label htmlFor="lineUpType">Hore</label>
                                <DropDownList
                                    name="lineUp"
                                    className="add-dialog-form-control"
                                    id="lineUpType"
                                    value={lineTypes.find(item => item.value === lineUpType)}
                                    onChange={(_, value) => setLineUpType(value.value)}
                                    data={lineTypes}
                                    textField="label"  
                                    dataItemKey="value"
                                >
                                </DropDownList>
                            </div>
                            <div className="line-settings-select">
                                <label htmlFor="lineDownType">Dole</label>
                                <DropDownList
                                    name="lineDown"
                                    className="add-dialog-form-control"
                                    id="lineDownType"
                                    value={lineTypes.find(item => item.value === lineDownType)}
                                    onChange={(_, value) => setLineDownType(value.value)}
                                    data={lineTypes}
                                    textField="label"  
                                    dataItemKey="value"
                                >
                                </DropDownList>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </Dialog >
    )
}
